<template>
    <div class="report-title-bar year-title-bar dsp-flex">
        <div class="report-title-side">
            <span class="report-title-back" @click="clickBack">
                <i class="iconfont icon-xiangzuo"></i>
            </span>
        </div>
        <div class="report-title-mid">
            <span v-if="detailInfo">{{detailInfo.f_name+(detailInfo.birthdayDate ? '('+detailInfo.birthdayDate.split(' ')[0]+')' : '')}}</span>
        </div>
        <div class="report-title-side" @click="clickReport">
            <div class="year-title-icon"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'YearTitleBar',
    computed: {
        detailInfo() {
            return this.$store.state.year.detailInfo;
        },
    },
    data() {
        return {
        }
    },
    methods: {
        clickBack() {
            var titleType = this.titleType, curParams = this.$router.history.current.params;
            console.log('ReportTitleBar---clickBack------', titleType, curParams);
            // 处理数据重置
            this.$store.dispatch('year/resetYearCharacterData');
            this.$store.dispatch('year/resetYearReportData');
            this.$store.dispatch('user/clearUpVipYearUpCountTimeFunc');
            // 处理页面跳转
            if(curParams.from && curParams.from != '') {
                if(curParams.from == 'collate') {
                    this.$router.replace('/collate');
                }else {
                    this.$router.replace('/detail/'+curParams.from+'/'+curParams.id);
                }
            }else {
                this.$router.replace('/record');
            }
        },
        clickReport() {
            var detailInfo = this.detailInfo,
                curParams = this.$router.history.current.params;
            console.log('YearTitleBar---clickBack------', curParams)
            this.$store.state.report.fromPage = 'detail';
            this.$store.dispatch('report/initReportAIConfig', {
                cb: ()=> {
                    this.$store.dispatch('report/getReportInfo', {
                        detailInfo: detailInfo,
                        cb: ()=> {
                            this.$store.dispatch('year/resetYearData');
                            if(curParams && curParams.from && curParams.from != '') {
                                this.$router.replace('/report/'+curParams.from+'/'+curParams.id);
                            }else {
                                this.$router.replace('/record');
                            }
                        }
                    })
                }
            });
        }
    }
}
</script>